import React from "react";
import { Box, useTheme } from "@mui/material";
import { Plus } from "lucide-react";

interface EmptyAddCardCstProps {
  addLabel: string;
  onAdd: () => void;
}

const EmptyAddCardCst: React.FC<EmptyAddCardCstProps> = ({
  addLabel,
  onAdd,
}) => {
  const theme = useTheme();

  return (
    <Box
      onClick={onAdd}
      sx={{
        minHeight: "120px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "12px",
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        cursor: "pointer",
        transition: "border-color 120ms ease",
        "&:hover": {
          borderColor: theme.palette.primary.main,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          color: theme.palette.primary.main,
          fontSize: "14px",
          fontWeight: 600,
        }}
      >
        {addLabel}
        <Plus size={16} />
      </Box>
    </Box>
  );
};

export default EmptyAddCardCst;
